import { decimalToUnits, MoneyError } from './money.js';
const D6 = 1000000n;
const D9 = 1000000000n;
const MAX_UNITS = 99999999999999999999n;
export function fundingReceiveTargetD6(localUnits, currency, decimals, snapshot) {
    return divide(units(localUnits) * D6 * D9, scale(decimals) * rate(snapshot, currency), 'up');
}
export function fundingSettlementValue(receivedD6, currency, decimals, snapshot, rounding = 'nearest') {
    return divide(units(receivedD6) * rate(snapshot, currency) * scale(decimals), D6 * D9, rounding);
}
export function convertFundingFiat(amountUnits, fromCurrency, fromDecimals, toCurrency, toDecimals, snapshot, rounding) {
    return divide(units(amountUnits) * rate(snapshot, toCurrency) * scale(toDecimals), rate(snapshot, fromCurrency) * scale(fromDecimals), rounding);
}
export function parseFundingRate(value) {
    const parsed = decimalToUnits(value, 9, MAX_UNITS);
    if (parsed === 0n)
        throw new Error('funding_fx_unavailable');
    return parsed.toString();
}
export function fundingRateIsCurrent(snapshot, now) {
    const observed = Date.parse(snapshot.observedAt);
    const expiry = Date.parse(snapshot.expiresAt);
    return (snapshot.base === 'USD' &&
        snapshot.convention === 'usdc-usd-reference' &&
        snapshot.source === 'exchange-rate-api' &&
        snapshot.ratesD9.USD === D9.toString() &&
        Number.isFinite(now) &&
        Number.isFinite(observed) &&
        Number.isFinite(expiry) &&
        observed <= now &&
        now < expiry);
}
function units(value) {
    if (!/^(0|[1-9]\d{0,19})$/.test(value))
        throw new MoneyError('invalid_amount');
    return BigInt(value);
}
function scale(decimals) {
    if (!Number.isInteger(decimals) || decimals < 0 || decimals > 4)
        throw new MoneyError('invalid_precision');
    return 10n ** BigInt(decimals);
}
function rate(snapshot, currency) {
    const value = snapshot.ratesD9[currency];
    if (!/^[A-Z]{3}$/.test(currency) || !value || !/^[1-9]\d{0,19}$/.test(value))
        throw new Error('funding_fx_unavailable');
    return BigInt(value);
}
function divide(numerator, denominator, rounding) {
    const quotient = numerator / denominator;
    const remainder = numerator % denominator;
    const roundUp = rounding === 'up' ? remainder > 0n : rounding === 'nearest' && remainder * 2n >= denominator;
    const result = quotient + (roundUp ? 1n : 0n);
    if (result > MAX_UNITS)
        throw new MoneyError('overflow');
    return result.toString();
}
